import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import CovidDeclarationList from './Component/CovidDeclarationList';
import { change, destroy, reset } from 'redux-form'
import Phi from '../../Phi/Phi';
import Constants from '../../Phi/Constants';

function getAssociationCandidate(profile, organization, role, child, selected){

    let selectedUserId, selectedOrganizationId, selectedUserRoleId

    if (child && child.length) {
        let selectedChild = child[selected]

        selectedUserId = selectedChild.userId
        selectedOrganizationId = selectedChild.schoolId || Constants.covidDeclarationDefaultOrganization
        selectedUserRoleId = selectedChild.role || Constants.roleIdMap.STUDENT
    }else {
        selectedUserId = profile.user_id
        selectedOrganizationId = organization.org_id || Constants.covidDeclarationDefaultOrganization
        selectedUserRoleId = role.role_type_id
    }

    return {
        selectedUserId, selectedOrganizationId, selectedUserRoleId
    }
} 

const mapStateToProps = (state, ownProps) => {

    let userOrganization = Phi.Storage.getItem('organization')
    let userProfile = Phi.Storage.getItem('profile')
    let userRole = Phi.Storage.getItem('roles')

    let childList = state.child.childList || []
    let selectedChild = state.child.selectedChild || 0

    userOrganization = userOrganization && JSON.parse(userOrganization) && JSON.parse(userOrganization)[0] || {}
    userProfile = userProfile && JSON.parse(userProfile) || {}
    userRole = userRole && JSON.parse(userRole)[0] || {}

    let { selectedUserId, selectedOrganizationId, selectedUserRoleId } = getAssociationCandidate(userProfile, userOrganization, userRole, childList, selectedChild)

    return {

        selectedUserId,
        selectedOrganizationId,
        selectedUserRoleId,

        userOrganization,
        userProfile,
        userRole,

        childList,
        selectedChild,

        responseCovidDeclarationList: state.child.responseCovidDeclarationList || {}
    }
};


const mapDispatchToProps = (dispatch) => ({

    getCovidDeclarationList: (params) => dispatch(Actions.getCovidDeclarationList(params)),
});


export default connect(mapStateToProps, mapDispatchToProps)(CovidDeclarationList)